import { globalGetService } from '@/utils/globalApiServices';
import { CnpItem } from './types';

export const getCnpList = async (
  params: {
    countryCode?: string;
    channelId?: string;
    soleProprietorEnabled?: boolean;
    cnpMigrationSupported?: boolean;
  } = {}
): Promise<CnpItem[]> => {
  const response = await globalGetService('dca/cnp', params);
  return response?.ok ? response.data : [];
};
